(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orli-gracie-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('orli-gracie-preview'))customElements.define('orli-gracie-preview',class extends HTMLElement{
 connectedCallback(){
  if(this.classList.contains('ogp-mobile'))return;
  this.scope=this.closest('product-info');if(!this.scope)return;
  this.queue=()=>{if(this.pending)return;this.pending=requestAnimationFrame(()=>{this.pending=0;this.update()})};
  this.observer=new MutationObserver(ms=>{if(ms.some(m=>!m.target.closest?.('orli-gracie-preview')))this.queue()});
  this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,characterData:true});
  this.scope.addEventListener('change',this.queue);this.scope.addEventListener('input',this.queue);this.update();
 }
 selected(label){
  const row=[...this.scope.querySelectorAll('.tpo_option-label')].find(e=>e.querySelector('.form__label')?.textContent.trim()===label&&!e.querySelector('input')?.disabled&&e.getClientRects().length);
  const value=row?.querySelector('.tpo_selected-option')?.textContent.trim()||'';
  const src=row?.querySelector('.tpo-image-select-value')?.getAttribute('src')||'';
  return {value,src};
 }
 update(){
  const row=this.scope.querySelector('.tpo_option-label');
  if(row&&(!this.mobile||!this.mobile.isConnected)){
   this.mobile=document.createElement('orli-gracie-preview');
   this.mobile.className='ogp-mobile ogp-inline';
   this.mobile.innerHTML=this.innerHTML;
   this.mobile.querySelector('.ogp-status').removeAttribute('aria-live');
   row.before(this.mobile);this.last=null;
  }

  const buttons=this.scope.querySelector('.product__submit__buttons');
  if(buttons&&(!this.previewButton||!this.previewButton.isConnected)){
   this.previewButton=document.createElement('button');
   this.previewButton.type='button';this.previewButton.className='ogp-view-preview';
   this.previewButton.innerHTML='View preview <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20V4m-6 6 6-6 6 6"/></svg>';
   this.previewButton.addEventListener('click',()=>{
    const target=this.mobile?.isConnected?this.mobile:this;
    target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
    const clearance=Math.min(window.innerHeight*.35,window.innerWidth<750?150:200);
    window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-clearance),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   });
   buttons.before(this.previewButton);
  }
  const initial=this.selected('Initial'),stone=this.selected('Birthstone');
  const initialStyle=this.selected('Initial Style').value.toLowerCase(),stoneStyle=this.selected('Birthstone Style').value.toLowerCase();
  const key=[initial.src,initial.value,stone.src,stone.value,initialStyle,stoneStyle].join('|');if(key===this.last)return;this.last=key;
  for(const preview of [this,this.mobile].filter(Boolean)){
   for(const [type,item,shape] of [['initial',initial,initialStyle],['stone',stone,stoneStyle]]){
    const img=preview.querySelector('.ogp-'+type);img.hidden=!item.value||!item.src;img.dataset.shape=shape;
    if(item.value&&item.src){img.src=item.src;img.alt=item.value;}
   }
   const text=[initial.value,stone.value].filter(Boolean).join(' · ');
   preview.querySelector('.ogp-status').textContent=text||this.querySelector('.ogp-status').dataset.empty;
   preview.querySelector('.ogp-stage').setAttribute('aria-label',text||this.querySelector('.ogp-status').dataset.empty);
  }
 }
 disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.pending);this.scope?.removeEventListener('change',this.queue);this.scope?.removeEventListener('input',this.queue);this.mobile?.remove();this.previewButton?.remove()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["orli-necklace-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('orli-necklace-guide'))customElements.define('orli-necklace-guide',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const d=this.querySelector('dialog'),b=this.querySelector('.ong-trigger');b.addEventListener('click',()=>d.showModal());this.querySelector('.ong-close').addEventListener('click',()=>d.close());d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close()}});d.addEventListener('close',()=>b.focus())}
});
  } catch(e) { console.error(e); }
})();

})();
